import { __assign } from "tslib";
// DS: I49
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Cart = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "-1 -1 26 26", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { transform: "translate(2 2)" },
                React.createElement("path", { d: "M0 0h3.5l1 3H20l-2 11H5L2.5 5l-1-3H0z" }),
                React.createElement("circle", { cx: "8", cy: "18", r: "2" }),
                React.createElement("circle", { cx: "16", cy: "18", r: "2" })))));
};
Cart.displayName = 'Cart';
export default Cart;
//# sourceMappingURL=Cart.js.map